const getState = () => ({
  sidebarMinified: false,
  sidebarMobile: false,
});

export default Object.assign(getState(), { getState: getState });
